<template>
  <div class="optimiser-panel-list-container">
    <h2 v-if="!selectedSheet" class="text-center mt-4">
      No optimisation sheet selected.<br />Select a sheet to view available panels
    </h2>

    <StationPanelScheduleList
      v-if="selectedSheet"
      ref="panelScheduleList"
      :displayOptimiserMode="true"
      :displaySearchBarAddon="true"
      :filterStockId="filterStockId"
      @panelClick="$emit('panelClick', $event)">

      <template v-slot:searchAddon="panelListData">
        <div class="text-right pr-2">
          <button data-toggle="dropdown" class="btn btn-default" type="button">
            <i class="far fa-ellipsis-h fa-lg"></i>
          </button>
          <ul class="dropdown-menu dropdown-lg dropdown-menu-right">
            <DropdownMenuItem @click="addPanelsFromScheduleList(panelListData.data.panelList)" icon="fa-plus-circle">Add Panels To Sheet</DropdownMenuItem>
          </ul>
        </div>
      </template>
      
    </StationPanelScheduleList>
  </div>
</template>

<style scoped>
.optimiser-panel-list-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>

<script>
import _ from 'lodash'
import StationPanelScheduleList from '@/apps/glass-production-station/src/components/schedule/stationPanelScheduleList'

export default {
  name: 'OptimiserPanelList',
  components: {
    StationPanelScheduleList
  },
  props: {
    selectedSheet: Object
  },
  computed: {
    filterStockId() {
      if(this.selectedSheet)
        return parseInt(this.selectedSheet.stockId)
      return null
    }
  },
  created() {
    this.debouncedReloadScheduleList = _.debounce(this.reloadPanelScheduleList, 250)
  },
  mounted() {
    // Subscribe to the generic sheet schedule list (virtual endpoint, not actual one)
    // Any updates to sheet allocations will refresh this endpoint
    this.subscribeEndpoint('/production/sheetschedule', () => {
      this.debouncedReloadScheduleList()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/production/sheetschedule')
  },
  methods: {
    reloadPanelScheduleList() {
      if(this.$refs.panelScheduleList)
        this.$refs.panelScheduleList.reloadPanelScheduleList()
    },
    addPanelsFromScheduleList(panels) {
      this.$emit('addPanelClick', panels);
    }
  }

}
</script>